// Highlights img
import locationIcon from "./assets/images/locationIcon.png";
import destinationIcon from "./assets/images/destinationIcon.png";
import securityIcon from "./assets/images/securityIcon.png";
import customerIcon from "./assets/images/customerIcon.png";
import TestimonialImg from "./assets/new-images/testimonial-img.png";

// Destination img
import destinationImage from "./assets/images/destinationImage.png";

// AboutUs img
import hightlightImg from "./assets/images/traveller-icon.png";
import hightlightImg2 from "./assets/images/experience-icon.png";
import hightlightImg3 from "./assets/images/star-rating-icon.png";
import hightlightImg4 from "./assets/images/rating-icon.png";
import hightlightImg5 from "./assets/images/rescheduel-icon.png";
import { register } from "react-scroll/modules/mixins/scroller";

// hotelchains img
import snowValley from "./assets/images/Snow valley resort.png";
import regenta from "./assets/images/regenta.png";
import clarks from "./assets/images/clarks.png";
import pax from "./assets/images/pax.png";
import eco from "./assets/images/eco.png";
import westernPlus from "./assets/images/western plus.png";
import dpolo from "./assets/images/d-polo.png";
import { Images } from "@fancyapps/ui";

// fetures Images

import dashboad from "./assets/images/fordashboad.png";
import hotel from "./assets/images/forhotel.png";
import inventory from "./assets/images/forinventory.png";
import offers from "./assets/images/foroffers.png";
import analytics from "./assets/images/foranalytics.png";
import notification from "./assets/images/fornotification.png";
import channel from "./assets/images/forchannel.png";
import support from "./assets/images/forsupport.png";

// packages Images
import packageIcon from "./assets/images/forinventory.png";
import forHotel from "./assets/images/forhotel.png";
import experience from "./assets/images/experience.png";
import packageIcn from "./assets/images/package-icon.png";
import customer from "./assets/images/customer-support.png";
import patner from "./assets/images/patner-icon.png";

// Highlights
export const hotelChainData = [
  {
    image: snowValley,
  },
  {
    image: regenta,
  },
  {
    image: clarks,
  },
  // {
  //   image: pax,
  // },
  {
    image: westernPlus,
  },
  {
    image: eco,
  },
  {
    image: dpolo,
  },
];

// fetures
export const Features = [
  {
    img: dashboad,
    head: "Centralised Dashboard",
    description: "Manage all hotel operations and bookings from one platform.",
  },
  {
    img: hotel,
    head: "Multi-Hotel Support",
    description: "Easily manage multiple hotels from a unified system.",
  },
  {
    img: inventory,
    head: "Inventory Management",
    description: "Maximize occupancy with real-time inventory tracking.",
  },
  {
    img: offers,
    head: "Special Offers",
    description: "Create and promote offers to attract more bookings.",
  },
  {
    img: analytics,
    head: "Advanced Analytics",
    description: "Use data insights to improve performance and revenue.",
  },
  {
    img: notification,
    head: "Automated Alerts",
    description: "Receive instant notifications on bookings and changes.",
  },
  {
    img: channel,
    head: "Channel Integration",
    description: "Sync your inventory across all booking platforms.",
  },
  {
    img: support,
    head: "Personalized Support",
    description: "Deliver customized, 24/7 guest support.",
  },
];

// packages
export const Packages = [
  {
    image: packageIcon,
    heading: "10,000+ Nights Booked",
    text: "Experience seamless travel planning with over 10,000 nights booked through our trusted services.",
  },
  {
    image: forHotel,
    heading: "150+ Exotic Hotels",
    text: "Explore and book from a curated list of over 150 exclusive properties in breathtaking destinations.",
  },
  {
    image: experience,
    heading: "22+ Years of Expertise",
    text: "Rely on over two decades of travel expertise to guide you through unforgettable journeys.",
  },
  {
    image: packageIcn,
    heading: "5,000+ Travel Packages Sold",
    text: "Choose from our wide range of travel packages tailored for every kind of adventurer, with over 5,000 satisfied travelers.",
  },
  {
    image: customer,
    heading: "24/7 Customer Support",
    text: "Enjoy peace of mind with round-the-clock support, ensuring your trip runs smoothly from start to finish.",
  },
  {
    image: patner,
    heading: "Trusted by 100+ Partners",
    text: "Collaborating with over 100 trusted hotel and travel partners to bring you the best rates and exclusive offers.",
  },
];

export const RegisterWork = [
  {
    heading: "Free Sign Up",
    svg: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_6951_3184"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="46"
          height="46"
        >
          <rect x="0.5" y="0.5" width="45" height="45" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6951_3184)">
          <path
            d="M24.3828 21.8279C25.1173 21.1372 25.6337 20.3368 25.9317 19.4268C26.2298 18.5168 26.3789 17.5853 26.3789 16.6322C26.3789 15.6793 26.2298 14.7479 25.9317 13.8379C25.6337 12.9279 25.1173 12.1275 24.3828 11.4365C25.8928 11.5586 27.1404 12.1163 28.1254 13.1096C29.1108 14.1033 29.6035 15.2775 29.6035 16.6322C29.6035 17.9871 29.1108 19.1613 28.1254 20.1547C27.1404 21.1483 25.8928 21.706 24.3828 21.8279ZM33.9181 34.6516C34.0538 34.3715 34.1619 34.0762 34.2425 33.7657C34.323 33.4551 34.3632 33.1407 34.3632 32.8225V31.6706C34.3632 30.807 34.1867 29.9854 33.8338 29.2058C33.4805 28.4261 32.9225 27.7824 32.16 27.2745C33.524 27.6447 34.7696 28.1747 35.8967 28.8645C37.0242 29.5543 37.5879 30.4897 37.5879 31.6706V32.8225C37.5879 33.3394 37.389 33.7734 36.9911 34.1245C36.5929 34.4759 36.1008 34.6516 35.515 34.6516H33.9181ZM37.5879 20.3581H34.5938C34.311 20.3581 34.074 20.2736 33.8827 20.1045C33.6914 19.9354 33.5957 19.7259 33.5957 19.4761C33.5957 19.2263 33.6914 19.0173 33.8827 18.8491C34.074 18.6809 34.311 18.5968 34.5938 18.5968H37.5879V15.955C37.5879 15.7054 37.6837 15.4963 37.8753 15.3275C38.0666 15.1587 38.3038 15.0743 38.5869 15.0743C38.8704 15.0743 39.1074 15.1587 39.2981 15.3275C39.4887 15.4963 39.584 15.7054 39.584 15.955V18.5968H42.5781C42.8609 18.5968 43.0979 18.6814 43.2892 18.8505C43.4805 19.0195 43.5762 19.229 43.5762 19.4788C43.5762 19.7286 43.4805 19.9376 43.2892 20.1058C43.0979 20.274 42.8609 20.3581 42.5781 20.3581H39.584V23C39.584 23.2495 39.4882 23.4586 39.2966 23.6274C39.1049 23.7962 38.8676 23.8806 38.5845 23.8806C38.3013 23.8806 38.0645 23.7962 37.8738 23.6274C37.6832 23.4586 37.5879 23.2495 37.5879 23V20.3581ZM16.3984 21.9159C14.7516 21.9159 13.3419 21.3986 12.1692 20.3638C10.9965 19.3291 10.4101 18.0852 10.4101 16.6322C10.4101 15.1791 10.9965 13.9352 12.1692 12.9005C13.3419 11.8658 14.7516 11.3484 16.3984 11.3484C18.0452 11.3484 19.4549 11.8658 20.6276 12.9005C21.8003 13.9352 22.3867 15.1791 22.3867 16.6322C22.3867 18.0852 21.8003 19.3291 20.6276 20.3638C19.4549 21.3986 18.0452 21.9159 16.3984 21.9159ZM2.42578 32.8225V31.7521C2.42578 31.025 2.66564 30.3447 3.14537 29.7112C3.62543 29.0781 4.271 28.5864 5.08208 28.2362C6.96572 27.4392 8.85053 26.8414 10.7365 26.4428C12.6225 26.0445 14.5098 25.8453 16.3984 25.8453C18.287 25.8453 20.1743 26.0445 22.0603 26.4428C23.9466 26.8414 25.8314 27.4392 27.7147 28.2362C28.5262 28.5864 29.1717 29.0781 29.6515 29.7112C30.1312 30.3447 30.371 31.025 30.371 31.7521V32.8225C30.371 33.3394 30.1721 33.7734 29.7742 34.1245C29.3763 34.4759 28.8843 34.6516 28.2981 34.6516H4.49872C3.91287 34.6516 3.42083 34.4759 3.02261 34.1245C2.62472 33.7734 2.42578 33.3394 2.42578 32.8225ZM16.3984 20.1547C17.4963 20.1547 18.4361 19.8098 19.2179 19.1199C19.9997 18.4301 20.3906 17.6008 20.3906 16.6322C20.3906 15.6635 19.9997 14.8342 19.2179 14.1444C18.4361 13.4546 17.4963 13.1096 16.3984 13.1096C15.3006 13.1096 14.3607 13.4546 13.5789 14.1444C12.7971 14.8342 12.4062 15.6635 12.4062 16.6322C12.4062 17.6008 12.7971 18.4301 13.5789 19.1199C14.3607 19.8098 15.3006 20.1547 16.3984 20.1547ZM4.42187 32.8903H28.375V31.7521C28.375 31.3614 28.2324 30.9945 27.9473 30.6513C27.6618 30.3082 27.267 30.018 26.7626 29.7808C25.1198 29.0787 23.426 28.5407 21.6811 28.1671C19.9361 27.7934 18.1753 27.6065 16.3984 27.6065C14.6219 27.6065 12.8612 27.7934 11.1163 28.1671C9.37101 28.5407 7.67699 29.0787 6.03421 29.7808C5.5302 30.018 5.13547 30.3082 4.85003 30.6513C4.56459 30.9945 4.42187 31.3614 4.42187 31.7521V32.8903Z"
            fill="#009A50"
          />
        </g>
      </svg>
    ),
    Step: "Step 1",
  },
  {
    heading: "Fill Property Details",
    svg: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_6951_3192"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="46"
          height="46"
        >
          <rect x="0.5" y="0.5" width="45" height="45" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6951_3192)">
          <path
            d="M19.0334 14.3459H32.5916C32.8572 14.3459 33.0798 14.4359 33.2595 14.6159C33.4392 14.7959 33.5291 15.0189 33.5291 15.2848C33.5291 15.5508 33.4392 15.7733 33.2595 15.9523C33.0798 16.1314 32.8572 16.2209 32.5916 16.2209H19.0334C18.7678 16.2209 18.5452 16.1311 18.3655 15.9514C18.1858 15.7714 18.0959 15.5484 18.0959 15.2825C18.0959 15.0166 18.1858 14.7941 18.3655 14.615C18.5452 14.4356 18.7678 14.3459 19.0334 14.3459ZM19.0334 19.5383H32.5916C32.8572 19.5383 33.0798 19.6283 33.2595 19.8083C33.4392 19.9883 33.5291 20.2113 33.5291 20.4772C33.5291 20.7431 33.4392 20.9656 33.2595 21.1447C33.0798 21.3237 32.8572 21.4133 32.5916 21.4133H19.0334C18.7678 21.4133 18.5452 21.3234 18.3655 21.1438C18.1858 20.9638 18.0959 20.7408 18.0959 20.4748C18.0959 20.2089 18.1858 19.9863 18.3655 19.8069C18.5452 19.6278 18.7678 19.5383 19.0334 19.5383ZM11.75 39.875C10.6922 39.875 9.80281 39.5144 9.08188 38.7931C8.36063 38.0722 8 37.1828 8 36.125V32.4472C8 32.0181 8.14516 31.6584 8.43547 31.3681C8.72578 31.0778 9.08547 30.9327 9.51453 30.9327H13.625V9.15406C13.625 8.32094 13.9216 7.60781 14.5147 7.01469C15.1078 6.42156 15.8209 6.125 16.6541 6.125H34.9709C35.8041 6.125 36.5172 6.42156 37.1103 7.01469C37.7034 7.60781 38 8.32094 38 9.15406V20.0431C38 20.3088 37.91 20.5314 37.73 20.7111C37.55 20.8908 37.327 20.9806 37.0611 20.9806C36.7952 20.9806 36.5727 20.8908 36.3936 20.7111C36.2145 20.5314 36.125 20.3088 36.125 20.0431V9.15406C36.125 8.8175 36.0169 8.54094 35.8006 8.32437C35.5841 8.10812 35.3075 8 34.9709 8H16.6541C16.3175 8 16.0409 8.10812 15.8244 8.32437C15.6081 8.54094 15.5 8.8175 15.5 9.15406V30.9327H21.7742C22.0398 30.9327 22.2625 31.0227 22.4422 31.2027C22.6219 31.3827 22.7117 31.6056 22.7117 31.8716C22.7117 32.1375 22.6219 32.36 22.4422 32.5391C22.2625 32.7181 22.0398 32.8077 21.7742 32.8077H9.875V36.125C9.875 36.6562 10.0547 37.1016 10.4141 37.4609C10.7734 37.8203 11.2188 38 11.75 38H21.7742C22.0398 38 22.2625 38.09 22.4422 38.27C22.6219 38.45 22.7117 38.673 22.7117 38.9389C22.7117 39.2048 22.6219 39.4273 22.4422 39.6064C22.2625 39.7855 22.0398 39.875 21.7742 39.875H11.75ZM27.1827 38.3605V36.3486C27.1827 36.157 27.2175 35.9716 27.2872 35.7922C27.3569 35.6125 27.4734 35.4409 27.6369 35.2775L37.1816 25.7802C37.3666 25.5948 37.5575 25.4698 37.7544 25.4052C37.9513 25.3402 38.1481 25.3077 38.345 25.3077C38.5597 25.3077 38.7706 25.348 38.9778 25.4286C39.1853 25.5089 39.3738 25.6297 39.5431 25.7909L41.2775 27.5614C41.4316 27.7464 41.5487 27.9388 41.6291 28.1384C41.7097 28.3378 41.75 28.5372 41.75 28.7366C41.75 28.9363 41.7116 29.1377 41.6347 29.3408C41.5578 29.5439 41.4387 29.738 41.2775 29.923L31.7802 39.4208C31.6167 39.5842 31.4452 39.7008 31.2655 39.7705C31.0861 39.8402 30.9006 39.875 30.7091 39.875H28.6972C28.2681 39.875 27.9084 39.7298 27.6181 39.4395C27.3278 39.1492 27.1827 38.7895 27.1827 38.3605ZM28.8416 38.2166H30.6228L37.1239 31.7042L36.2441 30.8136L35.3895 29.8977L28.8416 36.4353V38.2166ZM36.2441 30.8136L35.3895 29.8977L37.1239 31.7042L36.2441 30.8136Z"
            fill="#009A50"
          />
        </g>
      </svg>
    ),
    Step: "Step 2",
  },
  {
    heading: "Submit Documents",
    svg: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_6951_3200"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="46"
          height="46"
        >
          <rect x="0.5" y="0.5" width="45" height="45" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6951_3200)">
          <path
            d="M21.0205 29.4364L17.6741 26.09C17.5828 25.9988 17.4819 25.9303 17.3713 25.8847C17.2606 25.8391 17.1483 25.8162 17.0342 25.8162C16.9202 25.8162 16.8 25.8391 16.6738 25.8847C16.5475 25.9303 16.4387 25.9988 16.3475 26.09C16.1406 26.2969 16.0372 26.5198 16.0372 26.7589C16.0372 26.9983 16.1406 27.2213 16.3475 27.4278L19.9709 31.0625C20.1347 31.2259 20.3019 31.3408 20.4725 31.407C20.6431 31.473 20.8294 31.5059 21.0313 31.5059C21.2331 31.5059 21.4194 31.473 21.59 31.407C21.7606 31.3408 21.9278 31.2259 22.0916 31.0625L29.6525 23.5011C29.8353 23.3186 29.9327 23.0998 29.9445 22.8448C29.9567 22.5902 29.8594 22.3594 29.6525 22.1525C29.4459 21.9459 29.2212 21.8427 28.9784 21.8427C28.7356 21.8427 28.5108 21.9459 28.3039 22.1525L21.0205 29.4364ZM12.9041 39.875C12.0409 39.875 11.3203 39.5859 10.7422 39.0078C10.1641 38.4297 9.875 37.7091 9.875 36.8459V9.15406C9.875 8.29094 10.1641 7.57031 10.7422 6.99219C11.3203 6.41406 12.0409 6.125 12.9041 6.125H26.4289C26.833 6.125 27.2255 6.20672 27.6064 6.37016C27.9873 6.53359 28.3136 6.75109 28.5852 7.02266L35.2273 13.6648C35.4989 13.9364 35.7164 14.2627 35.8798 14.6436C36.0433 15.0245 36.125 15.417 36.125 15.8211V36.8459C36.125 37.7091 35.8359 38.4297 35.2578 39.0078C34.6797 39.5859 33.9591 39.875 33.0959 39.875H12.9041ZM26.75 13.9855V8H12.9041C12.6153 8 12.3508 8.12016 12.1105 8.36047C11.8702 8.60078 11.75 8.86531 11.75 9.15406V36.8459C11.75 37.1347 11.8702 37.3992 12.1105 37.6395C12.3508 37.8798 12.6153 38 12.9041 38H33.0959C33.3847 38 33.6492 37.8798 33.8895 37.6395C34.1298 37.3992 34.25 37.1347 34.25 36.8459V15.5H28.2645C27.8292 15.5 27.468 15.3564 27.1808 15.0692C26.8936 14.782 26.75 14.4208 26.75 13.9855Z"
            fill="#009A50"
          />
        </g>
      </svg>
    ),
    Step: "Step 3",
  },
  {
    heading: "Get Online Bookings",
    svg: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_6951_3208"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="46"
          height="46"
        >
          <rect x="0.5" y="0.5" width="45" height="45" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6951_3208)">
          <path
            d="M21.0313 30.8389L28.3039 23.5663C28.4867 23.3835 28.7055 23.2861 28.9602 23.2743C29.2152 23.2621 29.4459 23.3594 29.6525 23.5663C29.8594 23.7729 29.9628 23.9975 29.9628 24.2404C29.9628 24.4832 29.8594 24.708 29.6525 24.9149L22.0916 32.4758C21.7884 32.7789 21.435 32.9305 21.0313 32.9305C20.6275 32.9305 20.2741 32.7789 19.9709 32.4758L16.3475 28.8524C16.1647 28.6696 16.0673 28.4508 16.0555 28.1961C16.0433 27.9411 16.1406 27.7104 16.3475 27.5038C16.5541 27.2969 16.7788 27.1935 17.0216 27.1935C17.2644 27.1935 17.4892 27.2969 17.6961 27.5038L21.0313 30.8389ZM11.0291 39.875C10.1659 39.875 9.44531 39.586 8.86719 39.0079C8.28906 38.4297 8 37.7091 8 36.846V12.9041C8 12.041 8.28906 11.3204 8.86719 10.7422C9.44531 10.1641 10.1659 9.87504 11.0291 9.87504H14.3459V6.70207C14.3459 6.41113 14.4416 6.17004 14.6328 5.97879C14.8241 5.78785 15.065 5.69238 15.3556 5.69238C15.6466 5.69238 15.8877 5.78785 16.0789 5.97879C16.2698 6.17004 16.3653 6.41113 16.3653 6.70207V9.87504H29.7791V6.62988C29.7791 6.36301 29.8686 6.14004 30.0477 5.96098C30.2267 5.78191 30.4497 5.69238 30.7166 5.69238C30.9831 5.69238 31.2059 5.78191 31.385 5.96098C31.5644 6.14004 31.6541 6.36301 31.6541 6.62988V9.87504H34.9709C35.8341 9.87504 36.5547 10.1641 37.1328 10.7422C37.7109 11.3204 38 12.041 38 12.9041V36.846C38 37.7091 37.7109 38.4297 37.1328 39.0079C36.5547 39.586 35.8341 39.875 34.9709 39.875H11.0291ZM11.0291 38H34.9709C35.2597 38 35.5242 37.8799 35.7645 37.6396C36.0048 37.3993 36.125 37.1347 36.125 36.846V20.4041H9.875V36.846C9.875 37.1347 9.99516 37.3993 10.2355 37.6396C10.4758 37.8799 10.7403 38 11.0291 38ZM9.875 18.5286H36.125V12.9041C36.125 12.6154 36.0048 12.3508 35.7645 12.1105C35.5242 11.8702 35.2597 11.75 34.9709 11.75H11.0291C10.7403 11.75 10.4758 11.8702 10.2355 12.1105C9.99516 12.3508 9.875 12.6154 9.875 12.9041V18.5286Z"
            fill="#009A50"
          />
        </g>
      </svg>
    ),
    Step: "Step 4",
  },
];
// imageslider
export const destinationImages = [
  {
    id: 1,
    image: destinationImage,
    destinationName: "Destination Name",
  },
  {
    id: 2,
    image: destinationImage,
    destinationName: "Destination Name",
  },
  {
    id: 3,
    image: destinationImage,
    destinationName: "Destination Name",
  },
  {
    id: 4,
    image: destinationImage,
    destinationName: "Destination Name",
  },
  {
    id: 5,
    image: destinationImage,
    destinationName: "Destination Name",
  },
  {
    id: 6,
    image: destinationImage,
    destinationName: "Destination Name",
  },
];
// Testamonial Slider
export const testimonialReviews = [
  {
    id: 1,
    text: "We specially want to thank Mr. Sanjay Sharma (Owner) for such wonderful hospitality. We strongly recommend Mountain Mysteries for destination Himachal.",
    name: "Ravi Singh",
    image: TestimonialImg,
    rating: 5,
    date: "12 Aug, 2024",
  },
  {
    id: 2,
    text: "I would highly recommend to go for Mountain Mysteries. They provided us good hotels in Manali as well as Shimla with the best hospitalities.",
    name: "Nikita Bhadane",
    image: TestimonialImg,
    rating: 5,
    date: "12 Aug, 2024",
  },
  {
    id: 2,
    text: "Mountain Mysteries has planned everything very well. Excellent hotel arrangements. Good driver provided. Company has organised my trip very nicely. Nice locations..thanks all.",
    name: "Dhanendra Bande",
    image: TestimonialImg,
    rating: 5,
    date: "12 Aug, 2024",
  },
  {
    id: 3,
    text: "Great organization professional & cultural",
    name: "Hem Thakur",
    city: "Mumbai",
    image: TestimonialImg,
    rating: 5,
    date: "12 Aug, 2024",
  },
];

// Highlights
export const highlightData = [
  {
    id: 1,
    image: locationIcon,
    title: "All in one Platform",
    alt: "location-icon",
  },
  {
    id: 2,
    image: securityIcon,
    title: "Security",
    alt: "security-icon",
  },
  {
    id: 3,
    image: destinationIcon,
    title: "Expertise in Mountain Destinations",
    alt: "destination-icon",
  },
  {
    id: 4,
    image: customerIcon,
    title: "24x7 Customer Support",
    alt: "customer-icon",
  },
];
// destinationLinks
export const destinationsData = [
  {
    id: 0,
    heading: "Top Destinations in Himachal Pradesh",
    location: [
      "Shimla |",
      "Manali |",
      "Dharamshala |",
      "Dalhousie |",
      "Khajjiar |",
      "Kasol |",
      "Palampur |",
      "Bir-Billing |",
      "Spiti |",
      "Tabo |",
      "Chitkul |",
      "Chamba |",
      "Keylong |",
      "Losar |",
      "Chail |",
      "Kalpa |",
      "Theog |",
      "Barot Valley |",
      "Bhuntar |",
      "Sangla",
    ],
  },
  {
    id: 1,
    heading: "Popular Holiday Packages on Mountain Mysteries",
    location: [
      "Shimla |",
      "Manali |",
      "Dharamshala |",
      "Dalhousie |",
      "Khajjiar |",
      "Kasol |",
      "Palampur |",
      "Bir-Billing |",
      "Spiti |",
      "Tabo |",
      "Chitkul |",
      "Chamba |",
      "Keylong |",
      "Losar |",
      "Chail |",
      "Kalpa |",
      "Theog |",
      "Barot Valley |",
      "Bhuntar |",
      "Sangla",
    ],
  },
  {
    id: 2,
    heading: "Top properties in Himachal Pradesh",
    location: [
      "Shimla |",
      "Manali |",
      "Dharamshala |",
      "Dalhousie |",
      "Khajjiar |",
      "Kasol |",
      "Palampur |",
      "Bir-Billing |",
      "Spiti |",
      "Tabo |",
      "Chitkul |",
      "Chamba |",
      "Keylong |",
      "Losar |",
      "Chail |",
      "Kalpa |",
      "Theog |",
      "Barot Valley |",
      "Bhuntar |",
      "Sangla",
    ],
  },
  {
    id: 3,
    heading: "Top Activities in Himachal Pradesh",
    location: [
      "Shimla |",
      "Manali |",
      "Dharamshala |",
      "Dalhousie |",
      "Khajjiar |",
      "Kasol |",
      "Palampur |",
      "Bir-Billing |",
      "Spiti |",
      "Tabo |",
      "Chitkul |",
      "Chamba |",
      "Keylong |",
      "Losar |",
      "Chail |",
      "Kalpa |",
      "Theog |",
      "Barot Valley |",
      "Bhuntar |",
      "Sangla",
    ],
  },
];

// 50+ properties in accomodation page
export const locationOffer = [
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
  {
    city: "Shimla",
    property: "50+ Properties",
  },
];

// about us page highlights
export const highlight = [
  {
    image: hightlightImg,
    alternative_text: "traveller-icon",
    description: "Over 200,000 happy travelers",
  },
  {
    image: hightlightImg2,
    alternative_text: "experience-icon",
    description: "20 years of experience in travel industry",
  },
  {
    image: hightlightImg3,
    alternative_text: "star-rating-icon",
    description: "5/5 stars rating overall",
  },
  {
    image: hightlightImg4,
    alternative_text: "rating-icon",
    description: "#1 rated tour operator by customers",
  },
  {
    image: hightlightImg5,
    alternative_text: "rescheduel-icon",
    description: "Cancel or Reschedule anytime",
  },
];

// accordion in about us page
export const accordionItems = [
  {
    id: 1,
    header: "How do I book a tour with your agency?",
    content:
      "You can book a tour with us by visiting our website and filling out the booking form, or by contacting our customer service team directly via phone or email.",
  },
  {
    id: 2,
    header: "What destinations do you offer tours to?",
    content:
      "We offer tours to a wide range of destinations, including popular tourist spots as well as off-the-beaten-path locations. Our destinations include Shimla, Manali, Dharamshala, Dalhousie, Khajjiar, Kasol, Palampur, Bir-Billing, Spiti, Tabo, Chitkul, Chamba, Keylong, Losar, Chail, Kalpa, Theog, Barot Valley, Bhuntar, Sangla and many more.",
  },
  {
    id: 3,
    header: "Can you customize a tour itinerary to suit my preferences?",
    content:
      "Yes, we specialize in creating customized tour itineraries tailored to your preferences. Whether you're interested in cultural experiences, adventure activities, or relaxation, we can design a tour that meets your needs.",
  },
  {
    id: 4,
    header: "What types of accommodation do you provide during the tours?",
    content:
      "We offer a variety of accommodation options ranging from budget-friendly hotels to luxury resorts, ensuring your comfort and satisfaction throughout the tour.",
  },
  {
    id: 3,
    header: "Do your tour packages include meals and activities?",
    content:
      "Yes, our tour packages typically include meals as specified in the itinerary and a range of activities and excursions designed to enhance your travel experience.",
  },
  {
    id: 4,
    header: "How do I make payments for the tour packages?",
    content:
      "Payments can be made securely through our online payment gateway on our website. We accept major credit cards and other forms of electronic payment.",
  },
  {
    id: 4,
    header: "What is included in the tour package price?",
    content:
      "The tour package price includes accommodation, meals as specified, transportation during the tour, guided tours and activities as outlined in the itinerary, and applicable taxes and fees.",
  },
  {
    id: 4,
    header: "What are your cancellation and refund policies?",
    content:
      "Our cancellation and refund policies vary depending on the tour package and timing of cancellation. Please refer to our terms and conditions or contact our customer service team for detailed information.",
  },
  {
    id: 4,
    header:
      "Are there any additional fees or charges not included in the tour package price?",
    content:
      "Additional fees such as optional activities, personal expenses, travel insurance, and gratuities may not be included in the tour package price. Please check the specific inclusions and exclusions for each tour package.",
  },
  {
    id: 4,
    header: "How far in advance should I book a tour?",
    content:
      "We recommend booking your tour as early as possible to ensure availability, especially during peak travel seasons. Some tours may require booking several months in advance to secure preferred accommodations and activities.",
  },
];

// case Ertiga = 'Ertiga';
//     case InnovaCrysta = 'Innova Crysta';
//     case MaharajaTempo  = 'Maharaja Tempo ';
//     case Sedan = 'Sedan';
//     case TempoTraveller12Seater = 'Tempo Traveller 12 Seater';
//     case Urbenia12Seater = 'Urbenia 12 seater';

export const vehicleDetails = [
  {
    id: 1,
    name: "Ertiga",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M10.8425 23.0996C8.98132 23.0996 7.47229 24.6086 7.47229 26.4699C7.47229 28.3311 8.98132 29.8392 10.8425 29.8392C12.7038 29.8392 14.2128 28.3311 14.2128 26.4699C14.2128 24.6086 12.7038 23.0996 10.8425 23.0996ZM8.99995 25.0691L9.83475 25.9048C9.79039 25.9828 9.75579 26.068 9.73095 26.1567H8.54928C8.60428 25.7522 8.76397 25.3796 8.99995 25.0691ZM8.54928 26.7821H9.73095C9.75579 26.8708 9.79039 26.956 9.83475 27.035L8.99995 27.8698C8.76397 27.5593 8.60428 27.1876 8.54928 26.7821ZM10.5294 28.7622C10.1248 28.7072 9.75224 28.5475 9.44263 28.3116L10.2774 27.4768C10.3564 27.5211 10.4407 27.5566 10.5294 27.5814V28.7622ZM10.5294 25.3574C10.4407 25.3822 10.3564 25.4177 10.2774 25.4621L9.44263 24.6273C9.75224 24.3913 10.1248 24.2316 10.5294 24.1766V25.3574ZM11.1548 24.1766C11.5602 24.2316 11.9319 24.3913 12.2424 24.6273L11.4076 25.4621C11.3287 25.4177 11.2444 25.3822 11.1548 25.3574V24.1766ZM11.1548 28.7622V27.5814C11.2444 27.5566 11.3287 27.5211 11.4076 27.4768L12.2424 28.3116C11.9319 28.5484 11.5602 28.7072 11.1548 28.7622ZM12.6851 27.8698L11.8494 27.035C11.8938 26.956 11.9284 26.8708 11.9541 26.7821H13.1349C13.0799 27.1876 12.9211 27.5593 12.6851 27.8698ZM11.9541 26.1567C11.9284 26.068 11.8938 25.9828 11.8494 25.9048L12.6851 25.0691C12.9211 25.3796 13.0799 25.7522 13.1349 26.1567H11.9541Z"
          fill="#1C1B1F"
        />
        <path
          d="M30.7748 23.0996C28.9136 23.0996 27.4045 24.6086 27.4045 26.4699C27.4045 28.3311 28.9136 29.8392 30.7748 29.8392C32.636 29.8392 34.145 28.3311 34.145 26.4699C34.145 24.6086 32.636 23.0996 30.7748 23.0996ZM28.9322 25.0691L29.7679 25.9048C29.7226 25.9828 29.6889 26.068 29.6632 26.1567H28.4824C28.5374 25.7522 28.6962 25.3796 28.9322 25.0691ZM28.4824 26.7821H29.6632C29.6889 26.8708 29.7226 26.956 29.7679 27.035L28.9322 27.8698C28.6962 27.5593 28.5374 27.1876 28.4824 26.7821ZM30.4625 28.7622C30.0571 28.7072 29.6854 28.5475 29.3749 28.3116L30.2097 27.4768C30.2886 27.5211 30.3729 27.5566 30.4625 27.5814V28.7622ZM30.4625 25.3574C30.3729 25.3822 30.2886 25.4177 30.2097 25.4621L29.3749 24.6273C29.6854 24.3913 30.0571 24.2316 30.4625 24.1766V25.3574ZM31.0879 24.1766C31.4925 24.2316 31.8651 24.3913 32.1747 24.6273L31.3399 25.4621C31.2609 25.4177 31.1767 25.3822 31.0879 25.3574V24.1766ZM31.0879 28.7622V27.5814C31.1767 27.5566 31.2609 27.5211 31.3399 27.4768L32.1747 28.3116C31.8651 28.5484 31.4925 28.7072 31.0879 28.7622ZM32.6174 27.8698L31.7826 27.035C31.8261 26.956 31.8615 26.8708 31.8864 26.7821H33.0681C33.013 27.1876 32.8534 27.5593 32.6174 27.8698ZM31.8864 26.1567C31.8615 26.068 31.8261 25.9828 31.7826 25.9048L32.6174 25.0691C32.8534 25.3796 33.013 25.7522 33.0681 26.1567H31.8864Z"
          fill="#1C1B1F"
        />
        <path
          d="M40.2495 16.7378H38.94C38.5249 16.7378 38.1886 17.074 38.1886 17.4883V18.8226H37.8977C37.6759 18.2371 37.101 16.5737 36.6707 15.4044C36.3585 14.5545 35.5458 13.9921 34.6401 14.0001L19.8914 14.1207C19.4105 14.1243 18.9386 14.2503 18.5234 14.4924C16.5113 15.6661 13.4028 18.7285 13.4028 18.7285C13.4028 18.7285 7.76768 19.2937 6.34559 19.6946C4.87649 20.1089 5.02908 23.2379 5.02908 23.2379C4.12774 23.3266 4.03903 24.2581 4.03903 24.2581C3.78708 26.5061 4.83745 27.2451 4.83745 27.2451H6.95151C6.71464 26.0031 7.38976 22.0997 11.0723 22.3365C15.1372 22.5974 14.7193 27.1466 14.7193 27.1466L26.8634 27.1271C26.8962 24.2989 28.1959 23.1119 29.3261 22.6142C30.4049 22.1396 31.6557 22.2044 32.6813 22.7837C34.9674 24.0745 34.6108 27.1076 34.6108 27.1076L37.1658 27.0952C38.0751 27.0907 38.8096 26.3526 38.8096 25.4433V23.0995H40.2495C40.6638 23.0995 41 22.7633 41 22.3481V17.4883C41 17.074 40.6638 16.7378 40.2495 16.7378ZM24.1106 15.0975L23.5384 19.621C23.5286 19.6973 23.4639 19.7541 23.3876 19.7559L15.6845 19.849C15.5479 19.8508 15.4565 19.7097 15.5124 19.5855C15.8726 18.7765 17.1031 16.3377 19.2668 15.1924C19.6057 15.0132 19.9845 14.9236 20.3677 14.9236H23.958C24.0503 14.9236 24.1221 15.0052 24.1106 15.0975ZM30.0509 19.849H24.8656C24.783 19.849 24.7165 19.7807 24.7201 19.6982C24.8017 17.7438 25.1548 15.573 25.2452 15.0442C25.2568 14.9751 25.3171 14.9236 25.3881 14.9236H29.6313C29.7076 14.9236 29.7714 14.983 29.7759 15.0602C29.901 17.0829 30.1281 19.1118 30.1955 19.6875C30.2053 19.7736 30.1378 19.849 30.0509 19.849ZM36.0089 19.7638H31.4384C31.339 19.7638 31.2556 19.6911 31.2423 19.5926C31.1403 18.819 30.8706 15.9491 30.7943 15.1383C30.7837 15.023 30.875 14.9236 30.9913 14.9236H33.7148C34.5452 14.9236 35.2664 15.4967 35.4536 16.3058L36.2006 19.5217C36.2289 19.6459 36.1358 19.7638 36.0089 19.7638Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
  {
    id: 2,
    name: "Innova Crysta",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M10.8425 23.0996C8.98132 23.0996 7.47229 24.6086 7.47229 26.4699C7.47229 28.3311 8.98132 29.8392 10.8425 29.8392C12.7038 29.8392 14.2128 28.3311 14.2128 26.4699C14.2128 24.6086 12.7038 23.0996 10.8425 23.0996ZM8.99995 25.0691L9.83475 25.9048C9.79039 25.9828 9.75579 26.068 9.73095 26.1567H8.54928C8.60428 25.7522 8.76397 25.3796 8.99995 25.0691ZM8.54928 26.7821H9.73095C9.75579 26.8708 9.79039 26.956 9.83475 27.035L8.99995 27.8698C8.76397 27.5593 8.60428 27.1876 8.54928 26.7821ZM10.5294 28.7622C10.1248 28.7072 9.75224 28.5475 9.44263 28.3116L10.2774 27.4768C10.3564 27.5211 10.4407 27.5566 10.5294 27.5814V28.7622ZM10.5294 25.3574C10.4407 25.3822 10.3564 25.4177 10.2774 25.4621L9.44263 24.6273C9.75224 24.3913 10.1248 24.2316 10.5294 24.1766V25.3574ZM11.1548 24.1766C11.5602 24.2316 11.9319 24.3913 12.2424 24.6273L11.4076 25.4621C11.3287 25.4177 11.2444 25.3822 11.1548 25.3574V24.1766ZM11.1548 28.7622V27.5814C11.2444 27.5566 11.3287 27.5211 11.4076 27.4768L12.2424 28.3116C11.9319 28.5484 11.5602 28.7072 11.1548 28.7622ZM12.6851 27.8698L11.8494 27.035C11.8938 26.956 11.9284 26.8708 11.9541 26.7821H13.1349C13.0799 27.1876 12.9211 27.5593 12.6851 27.8698ZM11.9541 26.1567C11.9284 26.068 11.8938 25.9828 11.8494 25.9048L12.6851 25.0691C12.9211 25.3796 13.0799 25.7522 13.1349 26.1567H11.9541Z"
          fill="#1C1B1F"
        />
        <path
          d="M30.7748 23.0996C28.9136 23.0996 27.4045 24.6086 27.4045 26.4699C27.4045 28.3311 28.9136 29.8392 30.7748 29.8392C32.636 29.8392 34.145 28.3311 34.145 26.4699C34.145 24.6086 32.636 23.0996 30.7748 23.0996ZM28.9322 25.0691L29.7679 25.9048C29.7226 25.9828 29.6889 26.068 29.6632 26.1567H28.4824C28.5374 25.7522 28.6962 25.3796 28.9322 25.0691ZM28.4824 26.7821H29.6632C29.6889 26.8708 29.7226 26.956 29.7679 27.035L28.9322 27.8698C28.6962 27.5593 28.5374 27.1876 28.4824 26.7821ZM30.4625 28.7622C30.0571 28.7072 29.6854 28.5475 29.3749 28.3116L30.2097 27.4768C30.2886 27.5211 30.3729 27.5566 30.4625 27.5814V28.7622ZM30.4625 25.3574C30.3729 25.3822 30.2886 25.4177 30.2097 25.4621L29.3749 24.6273C29.6854 24.3913 30.0571 24.2316 30.4625 24.1766V25.3574ZM31.0879 24.1766C31.4925 24.2316 31.8651 24.3913 32.1747 24.6273L31.3399 25.4621C31.2609 25.4177 31.1767 25.3822 31.0879 25.3574V24.1766ZM31.0879 28.7622V27.5814C31.1767 27.5566 31.2609 27.5211 31.3399 27.4768L32.1747 28.3116C31.8651 28.5484 31.4925 28.7072 31.0879 28.7622ZM32.6174 27.8698L31.7826 27.035C31.8261 26.956 31.8615 26.8708 31.8864 26.7821H33.0681C33.013 27.1876 32.8534 27.5593 32.6174 27.8698ZM31.8864 26.1567C31.8615 26.068 31.8261 25.9828 31.7826 25.9048L32.6174 25.0691C32.8534 25.3796 33.013 25.7522 33.0681 26.1567H31.8864Z"
          fill="#1C1B1F"
        />
        <path
          d="M40.2495 16.7378H38.94C38.5249 16.7378 38.1886 17.074 38.1886 17.4883V18.8226H37.8977C37.6759 18.2371 37.101 16.5737 36.6707 15.4044C36.3585 14.5545 35.5458 13.9921 34.6401 14.0001L19.8914 14.1207C19.4105 14.1243 18.9386 14.2503 18.5234 14.4924C16.5113 15.6661 13.4028 18.7285 13.4028 18.7285C13.4028 18.7285 7.76768 19.2937 6.34559 19.6946C4.87649 20.1089 5.02908 23.2379 5.02908 23.2379C4.12774 23.3266 4.03903 24.2581 4.03903 24.2581C3.78708 26.5061 4.83745 27.2451 4.83745 27.2451H6.95151C6.71464 26.0031 7.38976 22.0997 11.0723 22.3365C15.1372 22.5974 14.7193 27.1466 14.7193 27.1466L26.8634 27.1271C26.8962 24.2989 28.1959 23.1119 29.3261 22.6142C30.4049 22.1396 31.6557 22.2044 32.6813 22.7837C34.9674 24.0745 34.6108 27.1076 34.6108 27.1076L37.1658 27.0952C38.0751 27.0907 38.8096 26.3526 38.8096 25.4433V23.0995H40.2495C40.6638 23.0995 41 22.7633 41 22.3481V17.4883C41 17.074 40.6638 16.7378 40.2495 16.7378ZM24.1106 15.0975L23.5384 19.621C23.5286 19.6973 23.4639 19.7541 23.3876 19.7559L15.6845 19.849C15.5479 19.8508 15.4565 19.7097 15.5124 19.5855C15.8726 18.7765 17.1031 16.3377 19.2668 15.1924C19.6057 15.0132 19.9845 14.9236 20.3677 14.9236H23.958C24.0503 14.9236 24.1221 15.0052 24.1106 15.0975ZM30.0509 19.849H24.8656C24.783 19.849 24.7165 19.7807 24.7201 19.6982C24.8017 17.7438 25.1548 15.573 25.2452 15.0442C25.2568 14.9751 25.3171 14.9236 25.3881 14.9236H29.6313C29.7076 14.9236 29.7714 14.983 29.7759 15.0602C29.901 17.0829 30.1281 19.1118 30.1955 19.6875C30.2053 19.7736 30.1378 19.849 30.0509 19.849ZM36.0089 19.7638H31.4384C31.339 19.7638 31.2556 19.6911 31.2423 19.5926C31.1403 18.819 30.8706 15.9491 30.7943 15.1383C30.7837 15.023 30.875 14.9236 30.9913 14.9236H33.7148C34.5452 14.9236 35.2664 15.4967 35.4536 16.3058L36.2006 19.5217C36.2289 19.6459 36.1358 19.7638 36.0089 19.7638Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
  {
    id: 3,
    name: "Maharaja Tempo ",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M4.09618 27.5194L4.6676 26.9623L5.03845 24.5185C5.16031 23.7125 5.74308 23.0532 6.52793 22.8322L9.24198 22.0678L11.7381 18.718C12.1468 18.1701 12.7901 17.8469 13.4735 17.8469H16.323L16.3397 17.4374H11.4618C10.926 17.4374 10.5566 16.8948 10.7595 16.399C11.2832 15.1222 12.6349 13.1136 15.9658 13.0447C20.2745 12.9562 35.4009 13.0235 39.229 13.0409C39.6785 13.0432 40.0411 13.408 40.0411 13.8576V27.2235H41V28.6206C41 29.1315 40.5875 29.547 40.0766 29.55L34.4011 29.5871C34.4707 29.3283 34.5078 29.0558 34.5078 28.775C34.5078 27.0471 33.1076 25.6462 31.3797 25.6462C29.6518 25.6462 28.2517 27.0471 28.2517 28.775C28.2517 29.0702 28.2926 29.3563 28.3698 29.6272L12.5365 29.7317C12.6334 29.4304 12.6856 29.1088 12.6856 28.775C12.6856 27.0471 11.2847 25.6462 9.55758 25.6462C7.83046 25.6462 6.42878 27.0471 6.42878 28.775C6.42878 29.1231 6.48554 29.4577 6.59074 29.7703H6.50068C6.50068 29.7703 4.35578 29.5031 4.00611 27.807C3.98492 27.7025 4.01974 27.5936 4.09618 27.5194ZM31.2617 22.0474H35.2957C35.4273 22.0474 35.5341 21.9407 35.5341 21.809V18.8051C35.5341 18.6734 35.4273 18.5667 35.2957 18.5667H31.2617C31.13 18.5667 31.0233 18.6734 31.0233 18.8051V21.809C31.0233 21.9407 31.13 22.0474 31.2617 22.0474ZM24.1458 22.0474H28.179C28.3107 22.0474 28.4174 21.9407 28.4174 21.809V18.8051C28.4174 18.6734 28.3107 18.5667 28.179 18.5667H24.1458C24.0141 18.5667 23.9074 18.6734 23.9074 18.8051V21.809C23.9074 21.9407 24.0141 22.0474 24.1458 22.0474ZM10.3757 22.0474H16.2928C16.3329 22.0474 16.3647 22.0148 16.3647 21.9755V18.6378C16.3647 18.5977 16.3329 18.5659 16.2928 18.5659H13.3698C13.0005 18.5659 12.6531 18.7415 12.4351 19.0397L10.3182 21.9331C10.2834 21.98 10.3167 22.0474 10.3757 22.0474Z"
          fill="#1C1B1F"
        />
        <path
          d="M31.4267 26.1737C32.8669 26.1737 34.0355 27.3415 34.0355 28.7826C34.0355 30.2236 32.8677 31.3907 31.4267 31.3907C29.9856 31.3907 28.8178 30.2236 28.8178 28.7826C28.8178 27.3415 29.9856 26.1737 31.4267 26.1737Z"
          fill="#1C1B1F"
        />
        <path
          d="M9.56213 26.1737C11.0024 26.1737 12.171 27.3415 12.171 28.7826C12.171 30.2236 11.0032 31.3907 9.56213 31.3907C8.12109 31.3907 6.95328 30.2236 6.95328 28.7826C6.95328 27.3415 8.12109 26.1737 9.56213 26.1737Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
  {
    id: 4,
    name: "Sedan",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M9.43708 22.6096C7.92118 22.6096 6.69214 23.8387 6.69214 25.3546C6.69214 26.8705 7.92118 28.0988 9.43708 28.0988C10.953 28.0988 12.182 26.8705 12.182 25.3546C12.182 23.8387 10.953 22.6096 9.43708 22.6096ZM7.93636 24.2137L8.61627 24.8943C8.58014 24.9579 8.55197 25.0272 8.53173 25.0995H7.56931C7.6141 24.77 7.74416 24.4666 7.93636 24.2137ZM7.56931 25.6089H8.53173C8.55197 25.6812 8.58014 25.7505 8.61627 25.8148L7.93636 26.4947C7.74416 26.2418 7.6141 25.9391 7.56931 25.6089ZM9.18202 27.2216C8.85254 27.1768 8.54908 27.0468 8.29691 26.8546L8.97682 26.1746C9.04113 26.2108 9.10977 26.2397 9.18202 26.2599V27.2216ZM9.18202 24.4485C9.10977 24.4687 9.04113 24.4976 8.97682 24.5338L8.29691 23.8538C8.54908 23.6616 8.85254 23.5316 9.18202 23.4868V24.4485ZM9.69142 23.4868C10.0216 23.5316 10.3244 23.6616 10.5773 23.8538L9.89734 24.5338C9.83303 24.4976 9.76439 24.4687 9.69142 24.4485V23.4868ZM9.69142 27.2216V26.2599C9.76439 26.2397 9.83303 26.2108 9.89734 26.1746L10.5773 26.8546C10.3244 27.0475 10.0216 27.1768 9.69142 27.2216ZM10.9378 26.4947L10.2572 25.8148C10.2933 25.7505 10.3215 25.6812 10.3424 25.6089H11.3041C11.2593 25.9391 11.13 26.2418 10.9378 26.4947ZM10.3424 25.0995C10.3215 25.0272 10.2933 24.9579 10.2572 24.8943L10.9378 24.2137C11.13 24.4666 11.2593 24.77 11.3041 25.0995H10.3424Z"
          fill="#1C1B1F"
        />
        <path
          d="M32.6279 22.6096C31.112 22.6096 29.8829 23.8387 29.8829 25.3546C29.8829 26.8705 31.112 28.0988 32.6279 28.0988C34.1438 28.0988 35.3728 26.8705 35.3728 25.3546C35.3728 23.8387 34.1438 22.6096 32.6279 22.6096ZM31.1272 24.2137L31.8078 24.8943C31.7709 24.9579 31.7435 25.0272 31.7225 25.0995H30.7608C30.8056 24.77 30.935 24.4666 31.1272 24.2137ZM30.7608 25.6089H31.7225C31.7435 25.6812 31.7709 25.7505 31.8078 25.8148L31.1272 26.4947C30.935 26.2418 30.8056 25.9391 30.7608 25.6089ZM32.3735 27.2216C32.0433 27.1768 31.7406 27.0468 31.4877 26.8546L32.1676 26.1746C32.2319 26.2108 32.3006 26.2397 32.3735 26.2599V27.2216ZM32.3735 24.4485C32.3006 24.4687 32.2319 24.4976 32.1676 24.5338L31.4877 23.8538C31.7406 23.6616 32.0433 23.5316 32.3735 23.4868V24.4485ZM32.8829 23.4868C33.2124 23.5316 33.5159 23.6616 33.768 23.8538L33.0881 24.5338C33.0238 24.4976 32.9552 24.4687 32.8829 24.4485V23.4868ZM32.8829 27.2216V26.2599C32.9552 26.2397 33.0238 26.2108 33.0881 26.1746L33.768 26.8546C33.5159 27.0475 33.2124 27.1768 32.8829 27.2216ZM34.1286 26.4947L33.4487 25.8148C33.4841 25.7505 33.513 25.6812 33.5332 25.6089H34.4957C34.4509 25.9391 34.3208 26.2418 34.1286 26.4947ZM33.5332 25.0995C33.513 25.0272 33.4841 24.9579 33.4487 24.8943L34.1286 24.2137C34.3208 24.4666 34.4509 24.77 34.4957 25.0995H33.5332Z"
          fill="#1C1B1F"
        />
        <path
          d="M39.3071 21.124V19.0553C39.3071 18.689 39.0369 18.379 38.6734 18.3299C38.1532 18.2598 37.5246 18.1738 37.5246 18.1738C35.6163 17.8523 35.7247 17.8205 33.4487 16.905C31.172 15.9896 28.6756 15.155 24.5173 15.0105C20.3584 14.866 17.4848 16.2468 16.4408 16.7764C15.3974 17.3068 11.3909 19.0647 11.3909 19.0647C7.65825 19.5828 3.81649 20.8711 3.53975 21.4491C3.26229 22.0272 3.47906 21.5575 3.14235 22.5091C2.80492 23.46 3.13007 25.0416 3.4675 25.3537C3.8042 25.6666 6.10044 25.9571 6.10044 25.9571C5.80926 22.8256 8.4516 21.8429 9.82371 22.0633C13.4075 22.6391 12.6452 26.2497 12.6452 26.2497L29.2399 25.8805C29.1438 22.4845 31.9856 21.4491 33.9718 22.2923C35.9581 23.1348 35.9718 25.3537 35.9718 25.3537C38.6814 24.8277 39.1149 25.1702 39.789 23.5929C40.4632 22.0149 39.3071 21.124 39.3071 21.124ZM22.797 19.1406L16.5513 19.3819C16.5513 19.3819 16.8244 18.6753 16.1821 18.1774C16.1821 18.1774 18.414 15.9614 23.5679 15.9137L22.797 19.1406ZM29.7818 18.9159L24.1142 19.0286L24.6279 15.9137C27.5419 15.9014 28.6857 16.2685 29.0759 16.4535C29.1821 16.5033 29.2702 16.585 29.3309 16.6854L30.039 17.84L29.7818 18.9159ZM32.9928 18.8718L31.3793 18.9202L29.883 16.7403L32.0419 17.6478C33.2341 18.1095 32.9928 18.8718 32.9928 18.8718Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
  {
    id: 5,
    name: "Tempo Traveller 12 Seater",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M4.09618 27.5194L4.6676 26.9623L5.03845 24.5185C5.16031 23.7125 5.74308 23.0532 6.52793 22.8322L9.24198 22.0678L11.7381 18.718C12.1468 18.1701 12.7901 17.8469 13.4735 17.8469H16.323L16.3397 17.4374H11.4618C10.926 17.4374 10.5566 16.8948 10.7595 16.399C11.2832 15.1222 12.6349 13.1136 15.9658 13.0447C20.2745 12.9562 35.4009 13.0235 39.229 13.0409C39.6785 13.0432 40.0411 13.408 40.0411 13.8576V27.2235H41V28.6206C41 29.1315 40.5875 29.547 40.0766 29.55L34.4011 29.5871C34.4707 29.3283 34.5078 29.0558 34.5078 28.775C34.5078 27.0471 33.1076 25.6462 31.3797 25.6462C29.6518 25.6462 28.2517 27.0471 28.2517 28.775C28.2517 29.0702 28.2926 29.3563 28.3698 29.6272L12.5365 29.7317C12.6334 29.4304 12.6856 29.1088 12.6856 28.775C12.6856 27.0471 11.2847 25.6462 9.55758 25.6462C7.83046 25.6462 6.42878 27.0471 6.42878 28.775C6.42878 29.1231 6.48554 29.4577 6.59074 29.7703H6.50068C6.50068 29.7703 4.35578 29.5031 4.00611 27.807C3.98492 27.7025 4.01974 27.5936 4.09618 27.5194ZM31.2617 22.0474H35.2957C35.4273 22.0474 35.5341 21.9407 35.5341 21.809V18.8051C35.5341 18.6734 35.4273 18.5667 35.2957 18.5667H31.2617C31.13 18.5667 31.0233 18.6734 31.0233 18.8051V21.809C31.0233 21.9407 31.13 22.0474 31.2617 22.0474ZM24.1458 22.0474H28.179C28.3107 22.0474 28.4174 21.9407 28.4174 21.809V18.8051C28.4174 18.6734 28.3107 18.5667 28.179 18.5667H24.1458C24.0141 18.5667 23.9074 18.6734 23.9074 18.8051V21.809C23.9074 21.9407 24.0141 22.0474 24.1458 22.0474ZM10.3757 22.0474H16.2928C16.3329 22.0474 16.3647 22.0148 16.3647 21.9755V18.6378C16.3647 18.5977 16.3329 18.5659 16.2928 18.5659H13.3698C13.0005 18.5659 12.6531 18.7415 12.4351 19.0397L10.3182 21.9331C10.2834 21.98 10.3167 22.0474 10.3757 22.0474Z"
          fill="#1C1B1F"
        />
        <path
          d="M31.4267 26.1737C32.8669 26.1737 34.0355 27.3415 34.0355 28.7826C34.0355 30.2236 32.8677 31.3907 31.4267 31.3907C29.9856 31.3907 28.8178 30.2236 28.8178 28.7826C28.8178 27.3415 29.9856 26.1737 31.4267 26.1737Z"
          fill="#1C1B1F"
        />
        <path
          d="M9.56213 26.1737C11.0024 26.1737 12.171 27.3415 12.171 28.7826C12.171 30.2236 11.0032 31.3907 9.56213 31.3907C8.12109 31.3907 6.95328 30.2236 6.95328 28.7826C6.95328 27.3415 8.12109 26.1737 9.56213 26.1737Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
  {
    id: 5,
    name: "Tempo Traveller 16 Seater",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M4.09618 27.5194L4.6676 26.9623L5.03845 24.5185C5.16031 23.7125 5.74308 23.0532 6.52793 22.8322L9.24198 22.0678L11.7381 18.718C12.1468 18.1701 12.7901 17.8469 13.4735 17.8469H16.323L16.3397 17.4374H11.4618C10.926 17.4374 10.5566 16.8948 10.7595 16.399C11.2832 15.1222 12.6349 13.1136 15.9658 13.0447C20.2745 12.9562 35.4009 13.0235 39.229 13.0409C39.6785 13.0432 40.0411 13.408 40.0411 13.8576V27.2235H41V28.6206C41 29.1315 40.5875 29.547 40.0766 29.55L34.4011 29.5871C34.4707 29.3283 34.5078 29.0558 34.5078 28.775C34.5078 27.0471 33.1076 25.6462 31.3797 25.6462C29.6518 25.6462 28.2517 27.0471 28.2517 28.775C28.2517 29.0702 28.2926 29.3563 28.3698 29.6272L12.5365 29.7317C12.6334 29.4304 12.6856 29.1088 12.6856 28.775C12.6856 27.0471 11.2847 25.6462 9.55758 25.6462C7.83046 25.6462 6.42878 27.0471 6.42878 28.775C6.42878 29.1231 6.48554 29.4577 6.59074 29.7703H6.50068C6.50068 29.7703 4.35578 29.5031 4.00611 27.807C3.98492 27.7025 4.01974 27.5936 4.09618 27.5194ZM31.2617 22.0474H35.2957C35.4273 22.0474 35.5341 21.9407 35.5341 21.809V18.8051C35.5341 18.6734 35.4273 18.5667 35.2957 18.5667H31.2617C31.13 18.5667 31.0233 18.6734 31.0233 18.8051V21.809C31.0233 21.9407 31.13 22.0474 31.2617 22.0474ZM24.1458 22.0474H28.179C28.3107 22.0474 28.4174 21.9407 28.4174 21.809V18.8051C28.4174 18.6734 28.3107 18.5667 28.179 18.5667H24.1458C24.0141 18.5667 23.9074 18.6734 23.9074 18.8051V21.809C23.9074 21.9407 24.0141 22.0474 24.1458 22.0474ZM10.3757 22.0474H16.2928C16.3329 22.0474 16.3647 22.0148 16.3647 21.9755V18.6378C16.3647 18.5977 16.3329 18.5659 16.2928 18.5659H13.3698C13.0005 18.5659 12.6531 18.7415 12.4351 19.0397L10.3182 21.9331C10.2834 21.98 10.3167 22.0474 10.3757 22.0474Z"
          fill="#1C1B1F"
        />
        <path
          d="M31.4267 26.1737C32.8669 26.1737 34.0355 27.3415 34.0355 28.7826C34.0355 30.2236 32.8677 31.3907 31.4267 31.3907C29.9856 31.3907 28.8178 30.2236 28.8178 28.7826C28.8178 27.3415 29.9856 26.1737 31.4267 26.1737Z"
          fill="#1C1B1F"
        />
        <path
          d="M9.56213 26.1737C11.0024 26.1737 12.171 27.3415 12.171 28.7826C12.171 30.2236 11.0032 31.3907 9.56213 31.3907C8.12109 31.3907 6.95328 30.2236 6.95328 28.7826C6.95328 27.3415 8.12109 26.1737 9.56213 26.1737Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
  {
    id: 6,
    name: "Urbenia 12 seater",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M4.09618 27.5194L4.6676 26.9623L5.03845 24.5185C5.16031 23.7125 5.74308 23.0532 6.52793 22.8322L9.24198 22.0678L11.7381 18.718C12.1468 18.1701 12.7901 17.8469 13.4735 17.8469H16.323L16.3397 17.4374H11.4618C10.926 17.4374 10.5566 16.8948 10.7595 16.399C11.2832 15.1222 12.6349 13.1136 15.9658 13.0447C20.2745 12.9562 35.4009 13.0235 39.229 13.0409C39.6785 13.0432 40.0411 13.408 40.0411 13.8576V27.2235H41V28.6206C41 29.1315 40.5875 29.547 40.0766 29.55L34.4011 29.5871C34.4707 29.3283 34.5078 29.0558 34.5078 28.775C34.5078 27.0471 33.1076 25.6462 31.3797 25.6462C29.6518 25.6462 28.2517 27.0471 28.2517 28.775C28.2517 29.0702 28.2926 29.3563 28.3698 29.6272L12.5365 29.7317C12.6334 29.4304 12.6856 29.1088 12.6856 28.775C12.6856 27.0471 11.2847 25.6462 9.55758 25.6462C7.83046 25.6462 6.42878 27.0471 6.42878 28.775C6.42878 29.1231 6.48554 29.4577 6.59074 29.7703H6.50068C6.50068 29.7703 4.35578 29.5031 4.00611 27.807C3.98492 27.7025 4.01974 27.5936 4.09618 27.5194ZM31.2617 22.0474H35.2957C35.4273 22.0474 35.5341 21.9407 35.5341 21.809V18.8051C35.5341 18.6734 35.4273 18.5667 35.2957 18.5667H31.2617C31.13 18.5667 31.0233 18.6734 31.0233 18.8051V21.809C31.0233 21.9407 31.13 22.0474 31.2617 22.0474ZM24.1458 22.0474H28.179C28.3107 22.0474 28.4174 21.9407 28.4174 21.809V18.8051C28.4174 18.6734 28.3107 18.5667 28.179 18.5667H24.1458C24.0141 18.5667 23.9074 18.6734 23.9074 18.8051V21.809C23.9074 21.9407 24.0141 22.0474 24.1458 22.0474ZM10.3757 22.0474H16.2928C16.3329 22.0474 16.3647 22.0148 16.3647 21.9755V18.6378C16.3647 18.5977 16.3329 18.5659 16.2928 18.5659H13.3698C13.0005 18.5659 12.6531 18.7415 12.4351 19.0397L10.3182 21.9331C10.2834 21.98 10.3167 22.0474 10.3757 22.0474Z"
          fill="#1C1B1F"
        />
        <path
          d="M31.4267 26.1737C32.8669 26.1737 34.0355 27.3415 34.0355 28.7826C34.0355 30.2236 32.8677 31.3907 31.4267 31.3907C29.9856 31.3907 28.8178 30.2236 28.8178 28.7826C28.8178 27.3415 29.9856 26.1737 31.4267 26.1737Z"
          fill="#1C1B1F"
        />
        <path
          d="M9.56213 26.1737C11.0024 26.1737 12.171 27.3415 12.171 28.7826C12.171 30.2236 11.0032 31.3907 9.56213 31.3907C8.12109 31.3907 6.95328 30.2236 6.95328 28.7826C6.95328 27.3415 8.12109 26.1737 9.56213 26.1737Z"
          fill="#1C1B1F"
        />
      </svg>
    ),
  },
];

export const hotelDestinationActivities = [
  {
    vendor_id: 1,
    slug: "backwater-houseboat-cruise",
    name: "Backwater Houseboat Cruise",
    content:
      "Experience the serene beauty of Kerala's backwaters on a traditional houseboat.",
    status: "active",
    show_online: true,
    activity_price: 7000,
    created_by: "admin",
    updated_by: "admin",
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/5b/67/37/feel-the-refreshing-backwater.jpg?w=1200&h=1200&s=1",
    location: "Alleppey, Kerala",
  },
  {
    vendor_id: 2,
    slug: "desert-safari-camel-ride",
    name: "Desert Safari & Camel Ride",
    content:
      "Embark on an adventurous desert safari followed by a traditional camel ride in the Thar Desert.",
    status: "active",
    show_online: true,
    activity_price: 4500,
    created_by: "admin",
    updated_by: "admin",
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/5b/67/37/feel-the-refreshing-backwater.jpg?w=1200&h=1200&s=1",

    location: "Jaisalmer, Rajasthan",
  },
  {
    vendor_id: 3,
    slug: "ayurvedic-spa-retreat",
    name: "Ayurvedic Spa & Wellness Retreat",
    content:
      "Rejuvenate your body and mind with authentic Ayurvedic treatments in a tranquil setting.",
    status: "active",
    show_online: true,
    activity_price: 6000,
    created_by: "admin",
    updated_by: "admin",
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/5b/67/37/feel-the-refreshing-backwater.jpg?w=1200&h=1200&s=1",

    location: "Rishikesh, Uttarakhand",
  },
  {
    vendor_id: 4,
    slug: "tea-plantation-tour",
    name: "Tea Plantation Tour",
    content:
      "Discover the lush tea gardens of Munnar and enjoy a guided tour of tea processing.",
    status: "active",
    show_online: true,
    activity_price: 2000,
    created_by: "admin",
    updated_by: "admin",
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/5b/67/37/feel-the-refreshing-backwater.jpg?w=1200&h=1200&s=1",

    location: "Munnar, Kerala",
  },
  {
    vendor_id: 5,
    slug: "heritage-walk-fort-exploration",
    name: "Heritage Walk & Fort Exploration",
    content:
      "Explore the rich history of Jaipur with a guided heritage walk and fort visit.",
    status: "active",
    show_online: true,
    activity_price: 3000,
    created_by: "admin",
    updated_by: "admin",
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/5b/67/37/feel-the-refreshing-backwater.jpg?w=1200&h=1200&s=1",

    location: "Jaipur, Rajasthan",
  },
];

export const AccommodationTypeOptions = [
  {
    label: "Hotel",
    value: "hotel",
  },
  {
    label: "Camping",
    value: "camping",
  },
  {
    label: "Home Stay",
    value: "home-stay",
  },
  {
    label: "BnB",
    value: "bnb",
  },
  {
    label: "Guest House",
    value: "guest-house",
  },
  {
    label: "Boutique Hotel",
    value: "boutique-hotel",
  },
];

export const AccommodationCategoryOptions = [
  {
    label: "Budget",
    value: "budget",
  },
  {
    label: "Standard",
    value: "standard",
  },
  {
    label: "Deluxe",
    value: "deluxe",
  },
  {
    label: "Super Deluxe",
    value: "super-deluxe",
  },
  {
    label: "Luxury",
    value: "luxury",
  },
  {
    label: "Premium",
    value: "premium",
  },
];

export const AccommodationStarRatingOptions = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
];
